import React from 'react'

import TextInput from '../../components/form/TextInput'
import * as utilsLib from '../../../libraries/utils'
import { useI18N } from '../../../libraries/i18n/hook'
import SearchIcon from '../../../assets/icons/mag-glass.svg?react'
import IndustrySelectBox from './IndustrySelectBox'
import Button from '../../components/form/Button'
import FiltersBox from '../../components/layout/FiltersBox'
import { useCompanyFilter } from '../../../libraries/search/filters'

const CompaniesFilters: React.FC = () => {
  const [showFilters, setShowFilters] = React.useState(false)
  const { filters, setFilters } = useCompanyFilter()
  const { t } = useI18N()
  const [searchText, setSearchText] = React.useState(filters.text || '')

  React.useEffect(() => {
    setFilters({
      sortBy: '',
      text: '',
      industryIds: []
    })
  }, [])

  React.useEffect(() => {
    setSearchText(filters.text || '')
  }, [filters.text])

  const debouncedSetFilterText = React.useMemo(() => utilsLib.debounceFunc((e: React.ChangeEvent<HTMLInputElement>) => {
    setFilters({ text: e.target.value.trim() })
  }, 300), [setFilters])

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value
    setSearchText(text)
    debouncedSetFilterText(e)
  }
  const renderFilters = () => {
    return (
      <div className='my-6 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <TextInput icon={<SearchIcon className='w-5' />} className='w-full' value={searchText} onChange={handleTextChange} placeholder={t('content.searchByKeyword')} />
        <IndustrySelectBox onChange={setFilters} values={filters.industryIds} />
        <div className='flex sm:hidden justify-between mt-4'>
          <Button variant='secondary' outlined onClick={() => setFilters({})}>{t('content.remove.filters')}</Button>
          <Button variant='primary' onClick={() => setShowFilters(false)}>{t('content.see.results')}</Button>
        </div>
      </div>
    )
  }
  return (
    <FiltersBox toggleShowFilters={setShowFilters} showFilters={showFilters}>
      {renderFilters()}
    </FiltersBox>
  )
}

export default CompaniesFilters
